<!--
 * @Author: OnismYY 2848335733@qq.com
 * @LastEditTime: 2025-10-14 10:00:40
 * @FilePath: \h5-front\src\views\pages\fast-app\fast-app-edit.vue
 * @Description: 快捷应用编辑
-->
<template>
  <div>
    <v-dialog v-model="editDialog" fullscreen :scrim="false" transition="dialog-bottom-transition">
      <v-card>
        <toolbar-title
          :title="$t('home.quickApp')"
          :closeText="$t('common.save')"
          @close="emits('closeDialog')"
          @save="saveAndClose"
        />

        <div class="mt-6">
          <v-list-item :title="$t('home.myApp')">
            <template v-slot:subtitle="">
              <p class="mt-6" v-if="displayedViews.length === 0">
                {{ $t('home.myAppTips') }}
              </p>
              <text v-else>{{ $t('home.dragSort') }}</text>
            </template>
          </v-list-item>

          <draggable
            v-model="displayedViews"
            :disabled="!sortEnabled"
            group="people"
            @start="dragging = true"
            @end="dragging = false"
            item-key="id"
            style="cursor: pointer"
          >
            <template #item="{ element, index }">
              <v-col cols="4" sm="4" md="2" lg="1" :style="{ display: 'inline-block' }">
                <v-card class="card-shadow">
                  <v-card-text class="text-center pb-0">
                    <!-- <svg aria-hidden="true" class="svgicon mx-auto">
                      <use :xlink:href="element.icon"></use>
                    </svg> -->
                    <ali-icon-font :name="element.icon" size="2em" color="" />
                    <p class="mt-4 text-caption text-lg-subtitle-2 text-no-wrap text-truncate">
                      {{ translate_i18n(element.name) }}
                    </p>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="removeFromDisplay(element)" icon="mdi mdi-trash-can-outline" size="small"></v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-col>
            </template>
          </draggable>
        </div>

        <div class="mt-6">
          <v-list-item :title="$t('home.allApp')">
            <template v-slot:subtitle="" v-if="hiddenViews.length === 0">
              <p class="mt-6">{{ $t('home.allAppTips') }}</p>
            </template>
          </v-list-item>

          <v-row class="pa-3">
            <v-col cols="4" sm="4" md="2" lg="1" v-for="(item, itemIndex) in hiddenViews" :key="itemIndex">
              <v-card>
                <v-card-text class="text-center pb-0">
                  <ali-icon-font :name="item.icon" size="2em" color="" />
                  <p class="mt-4 text-caption text-lg-subtitle-2 text-no-wrap text-truncate">
                    {{ translate_i18n(item.name) }}
                  </p>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="addToDisplay(item)" icon="mdi mdi-plus" size="small"></v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
import draggable from 'vuedraggable'
import $toastMessage from '@/components/toast-message/index'
import { translate_i18n } from '@/plugins/i18n'
import { filterShortcuts } from './fast-store'
import quickIconsApi from '@/models/quick-icons-api'
import { useFastStore } from './fast-store'

const fastStore = useFastStore()

const props = defineProps({
  editDialog: {
    type: Boolean,
    default: false
  },
  shortcutsList: {
    type: Array,
    default: () => []
  },
  id: {
    type: String,
    default: ''
  }
})

const { editDialog } = toRefs(props)
const emits = defineEmits()

const displayedViews = ref([]) // 我的菜单
const hiddenViews = ref([]) // 所有菜单

const sortEnabled = ref(true)
const dragging = ref(false)

// 新增菜单
function addToDisplay(view) {
  const index = hiddenViews.value.indexOf(view)
  if (index !== -1) {
    hiddenViews.value.splice(index, 1)
    displayedViews.value.push(view)
  }
}

// 移除菜单
function removeFromDisplay(view) {
  const index = displayedViews.value.findIndex((item) => item.name === view.name)
  if (index !== -1) {
    const removedView = displayedViews.value.splice(index, 1)[0]
    hiddenViews.value.push(removedView)
  }
}

const saveAndClose = async () => {
  let para = {
    id: props.id,
    quickIconsList: displayedViews.value.map((item) => item.name)
  }
  console.log(JSON.stringify(para))
  const res = await quickIconsApi.updateShortcut(para)
  $toastMessage.show({
    color: res.statusCode === 200 ? 'success' : '',
    variant: 'flat',
    message: res.message
  })
  await nextTick()
  emits('closeDialog')
}

watch(editDialog, (newVal) => {
  if (newVal) {
    displayedViews.value = props.shortcutsList

    // 过滤掉我的应用,剩余的显示在全部应用中
    console.log('所有菜单', fastStore.visibleMenuNames)
    console.log('我的应用>>>', props.shortcutsList)

    // 所有应用中过滤掉已经在“我的应用”中的快捷方式
    hiddenViews.value = filterShortcuts(fastStore.visibleMenuNames).filter(
      (shortcut) => !displayedViews.value.some((item) => item.name === shortcut.name)
    )

    console.log('全部应用++++++',hiddenViews.value);
  }
})
</script>

<style lang="scss" scoped>
.card-shadow {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px !important;
}
</style>
